import script from "./dashbStickyNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./dashbStickyNotes.vue?vue&type=script&setup=true&lang=js"

import "./dashbStickyNotes.vue?vue&type=style&index=0&id=3992ed66&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3992ed66"]])

export default __exports__